import { render, staticRenderFns } from "./RegistrationBranchTypes.vue?vue&type=template&id=53d01b06&"
import script from "./RegistrationBranchTypes.vue?vue&type=script&lang=ts&"
export * from "./RegistrationBranchTypes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports